import { joinNames } from '../../utils/common/formatText';
import { Metadata } from '../types';

import {
  LessonTemplate, RawLessonTemplate, RawShortLessonTemplate, ShortLessonTemplate,
} from './types';

export const toLessonTemplate = ({
  data, metadata,
}: {
  data: RawLessonTemplate, metadata: Metadata
}): {data: LessonTemplate, metadata: Metadata} => ({
  data: {
    ...data,
    id: `${data.course}#${data.lessonId}`,
    combinedLabel: joinNames([data?.lessonGroup, data?.label]),
  },
  metadata: {
    ...metadata,
    id: {
      hide: true,
      label: 'ID',
      type: 'text',
      editable: false,
    },
    combinedLabel: {
      label: 'Label',
      type: 'text',
      editable: false,
    },
  },
});

export const toShortLessonTemplates = ({
  data, metadata,
}: {
  data: RawShortLessonTemplate[], metadata: Metadata
}): {data: ShortLessonTemplate[], metadata: Metadata} => ({
  data: data.map((template) => ({
    ...template,
    id: `${template.course}#${template.lessonId}`,
    combinedLabel: joinNames([template?.lessonGroup, template?.label]),
  })),
  metadata: {
    ...metadata,
    id: {
      hide: true,
      label: 'ID',
      type: 'text',
      editable: false,
    },
    combinedLabel: {
      label: 'Label',
      type: 'text',
      editable: false,
    },
  },
});
